import { ComponentTypes } from "../../base/ComponentTypes";
import { ExpandButton } from "./ExpandButton";
import { ExpandTableCellStyles } from "./ExpandTableCellStyles";
import { StyleUtil } from "@mcleod/core";
import { TableCell } from "./TableCell";
import { TableCellProps } from "./TableCellProps";

enum InnerIds {
    BUTTON_EXPAND = "buttonExpand"
}

export class ExpandTableCell extends TableCell {
    static readonly FIXED_WIDTH = "40";
    private _buttonExpand: ExpandButton;
    
    constructor(props?: Partial<TableCellProps>) {
        const propsToUse = {
            ...props,
            fixedWidth: ExpandTableCell.FIXED_WIDTH,
            id: `${props.table.id}-${props.row.index}-expand`
        };
        super(propsToUse);
        this.allowDropInDesigner = false;

        this.createExpandButton();
        this.add(this.buttonExpand);

        this.makeSticky();
    }

    protected override addDefaultClassName() {
        this.element.classList.add(ExpandTableCellStyles.base);
    }

    private createExpandButton() {
        this.buttonExpand = new ExpandButton(this.row, this.createInnerComponentId(InnerIds.BUTTON_EXPAND));
    }

    /**
     * This convenience method provides access to the expand (chevron) button, in case it needs to be moved or otherwise
     * adjusted.  This method should not be needed often...if you find yourself here, ask why you need to alter/move
     * the button.
     */
    public get buttonExpand(): ExpandButton {
        return this._buttonExpand;
    }

    private set buttonExpand(value: ExpandButton) {
        this._buttonExpand = value;
    }

    public sync() {
        this.buttonExpand.sync();
        this.row.fillKeyHandlerGroup(true);
    }

    override _updateAfterMove() {
        this.sync();
    }

    public override get selectableInDesigner(): boolean {
        return false;
    }

    override isSerialized(): boolean {
        return false;
    }

    private makeSticky() {
        ExpandTableCell.makeStickyCommon(this);
        // this.backgroundColor = "McLeodWhite";
    }

    static makeStickyCommon(cell: TableCell) {
        // Don't make the column sticky when in the UI Designer, since the Designer Tools Column will be to its right
        if (cell.table._designer == null) {
            const zeroPixels = StyleUtil.numberAsPixels(0);
            if (cell.table.displayingExpandCellRight()) {
                cell._element.style.right = zeroPixels;
            } else {
                cell._element.style.left = zeroPixels;
            }
            cell._element.classList.add('sticky-cell');
            cell._element.style.position = "sticky";
            cell.zIndex = 10;
        }
    }
}
ComponentTypes.registerComponentType("expandcell", {
    constructor: ExpandTableCell.prototype.constructor
});
